module.exports = __webpack_public_path__ + "img/retrospect-process-1.c2ddb980.jpg";